<template>
    <div class="text-margin">
        
        <el-form-item
            label="客服微信号"
        >
            <el-input
                v-model="username"
                size="mini"
            />
        </el-form-item>
        <el-form-item
            label="微信群号"
        >
            <el-input
                v-model="group_name"
                size="mini"
            />
        </el-form-item>
    </div>
</template>

<script>

export default {
    name: 'FormWeChatGroup.vue',
    props: {
        value: {
            type: Object,
            default: function () {
                return {
                    nickname: '',
                    username: '',
                    group_name: ''
                }
            }
        }
    },
    data() {
        return {
            module: {
                weChatGroup: {
                    nickname: '',
                    username: '',
                    group_name: ''
                }
            }
        }
    },
    created(){
        
    },
    computed: {
        username: {
            get: function() {
                return this.value ? this.value.username : ''
            },
            set: function(value) {
                this.$emit('input', {username: value, group_name: this.group_name, nickname: ''})
            }
        },
        group_name: {
            get: function() {
                return this.value ? this.value.group_name : ''
            },
            set: function(value) {
                this.$emit('input', {username: this.username, group_name: value, nickname: ''})
            }
        }
    },
    mounted(){
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
